import React, { useContext } from "react";
import { FirebaseContext } from "../../../FirebaseContext";
import { SelectionButton } from "../SelectionButton/"
import './SelectBackground.css';
import acolyteIcon from '../../../Images/backgrounds/acolyte.png';
import charlatanIcon from '../../../Images/backgrounds/charlatan.png';
import criminalIcon from '../../../Images/backgrounds/criminal.png';
import entertainerIcon from '../../../Images/backgrounds/entertainer.png';
import hermitIcon from '../../../Images/backgrounds/hermit.png';
import nobleIcon from '../../../Images/backgrounds/noble.png';
import sageIcon from '../../../Images/backgrounds/sage.png';
import sailorIcon from '../../../Images/backgrounds/sailor.png';
import soldierIcon from '../../../Images/backgrounds/soldier.png';
import artisanIcon from '../../../Images/backgrounds/artisan.png';
import farmerIcon from '../../../Images/backgrounds/farmer.png';
import wayfarerIcon from '../../../Images/backgrounds/wayfarer.png';
import merchantIcon from '../../../Images/backgrounds/merchant.png';
import guardIcon from '../../../Images/backgrounds/guard.png';
import guideIcon from '../../../Images/backgrounds/guide.png';
import scribeIcon from '../../../Images/backgrounds/scribe.png';

export const SelectBackground = () => {
    const { characterJSON, setCharacterJSON } = useContext(FirebaseContext);

    const selectingBackground = (backgroundName) => {
        if (characterJSON.background === backgroundName) {
            setCharacterJSON(prevState => ({
                ...prevState,
                background: ''
            }));
        } else {
            setCharacterJSON(prevState => ({
                ...prevState,
                background: backgroundName
            }));
        }
    };

    const backgrounds = [
        { name: 'Acolyte', icon: acolyteIcon, disabled: false },
        { name: 'Artisan', icon: artisanIcon, disabled: false }, // No import for this
        { name: 'Charlatan', icon: charlatanIcon, disabled: false },
        { name: 'Criminal', icon: criminalIcon, disabled: false },
        { name: 'Entertainer', icon: entertainerIcon, disabled: false },
        { name: 'Farmer', icon: farmerIcon, disabled: false },  // No import for this
        { name: 'Guard', icon: guardIcon, disabled: false },   // No import for this
        { name: 'Guide', icon: guideIcon, disabled: false },   // No import for this
        { name: 'Hermit', icon: hermitIcon, disabled: false },
        { name: 'Merchant', icon: merchantIcon, disabled: false }, // No import for this
        { name: 'Noble', icon: nobleIcon, disabled: false },
        { name: 'Sage', icon: sageIcon, disabled: false },
        { name: 'Sailor', icon: sailorIcon, disabled: false },
        { name: 'Scribe', icon: scribeIcon, disabled: false },  // No import for this
        { name: 'Soldier', icon: soldierIcon, disabled: false },
        { name: 'Wayfarer', icon: wayfarerIcon, disabled: false } // No import for this
    ];    

    return (
        <div className="content-wrapper">
            <h2 className="character-heading">
                Choose a background:
            </h2>    
            <div className="character-grid">
                {backgrounds.map((charBackground, index) => (
                    <SelectionButton
                        key={charBackground.name}
                        name={charBackground.name}
                        icon={charBackground.icon}
                        isSelected={characterJSON.background === charBackground.name}
                        onClick={() => selectingBackground(charBackground.name)}
                        disabled={charBackground.disabled}
                    /> 
                ))}
            </div>
        </div>
    );
}
